import { __assign } from "tslib";
import { createIvrsApi, ivrsRelativePath } from './';
import { createFakePostResponder, createFakeGetResponder, createFakePutResponder, createFakeDeleteResponder } from '../../test-utils';
import { createHttpTestKit } from '../../http/test-kit';
export var createIvrsApiTestKit = function (parentPath) {
    var fakeHttp = createHttpTestKit();
    var api = createIvrsApi(parentPath, fakeHttp);
    var url = parentPath + ivrsRelativePath;
    var testKit = {
        whenGetFlows: function () { return createFakeGetResponder(fakeHttp, "" + url); },
        whenAddFlow: function (dto) { return createFakePostResponder(fakeHttp, "" + url)(dto); },
        whenUpdateFlow: function (dto) {
            return createFakePutResponder(fakeHttp, url + "/" + dto.id)(dto.data);
        },
        whenDeleteFlow: function (dto) {
            return createFakeDeleteResponder(fakeHttp, url + "/" + dto.id);
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map